import React from 'react';
import './DiscretizationLayout.css';

const DiscretizationLayout = ({ title, step, onStepClick, datasetLoaded, results, children }) => {
  const steps = ['Parameters', 'Run Analysis', 'Results'];

  const canAccessStep = (targetStep) => {
    if (targetStep === 0) return true;
    if (targetStep === 1) return datasetLoaded;
    if (targetStep === 2) return results;
    return false;
  };

  return (
    <div className="discretization-container">
      <h1 className="page-title">{title}</h1>
      
      <div className="steps-indicator">
        {steps.map((label, idx) => {
          const isAccessible = canAccessStep(idx);
          const isActive = step >= idx;
          
          return (
            <div 
              key={idx}
              className={`step ${isActive ? 'active' : ''} ${!isAccessible ? 'disabled' : ''}`}
              onClick={() => isAccessible && onStepClick && onStepClick(idx)}
              style={{ cursor: isAccessible ? 'pointer' : 'not-allowed' }}
            >
              <span className="step-number">{idx + 1}</span>
              <span className="step-label">{label}</span>
            </div>
          );
        })}
      </div>

      <div className="step-content">
        {children}
      </div>
    </div>
  );
};

export default DiscretizationLayout;
